import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { dateStringFromISO8601, propExists } from '../../../../../../../../../../utils';
import { CustomerMembership, CustomerMembershipCustomer } from '../../../../../../../../../../models/membership';

@Component({
  selector: 'app-edit-recurring-customer-membership-undo-scheduled-freeze-individual',
  templateUrl: './edit-recurring-customer-membership-undo-scheduled-freeze-individual.component.html',
  styleUrls: ['./edit-recurring-customer-membership-undo-scheduled-freeze-individual.component.css']
})
export class EditRecurringCustomerMembershipUndoScheduledFreezeIndividualComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() unfreezeOnly: boolean;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public member: CustomerMembershipCustomer;

  public errorMessage = '';

  public dateStringFromISO8601 = dateStringFromISO8601;
  public propExists = propExists;

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });

    for (const member of this.getActionableMembers()) {
      this.member = member
    }
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  public getActionableMembers(): CustomerMembershipCustomer[] {
    if (this.unfreezeOnly) {
      return this.membership.all_customers.filter(cmc => (cmc.member_unfreeze_date !== null));
    } else {
      return this.membership.all_customers.filter(cmc => ((cmc.member_freeze_date !== null) || (cmc.member_unfreeze_date !== null)));
    }
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    this.customerService
      .undoScheduledMemberFreeze(
        this.member,
        this.unfreezeOnly
      )
      .then(() => {
        if (propExists(this.membership.membership_freeze_date)) {
          this.savedCallback('Member freeze successfully unscheduled.');
        } else {
          this.savedCallback('Member unfreeze successfully unscheduled.');
        }
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          if (propExists(this.membership.membership_freeze_date)) {
            this.errorMessage = 'You do not have permission to unschedule this member\'s freeze.';
          } else {
            this.errorMessage = 'You do not have permission to unschedule this member\'s unfreeze.';
          }
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
